import { Store } from '@ngrx/store';
import { AppleDevice } from '@era/locations-sdk';
import { ConfigurationProfile } from '@rocksoft/mdm-sdk-v2';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppleProfilesStoreSelectors } from '@era/stores';
import { Injectable } from '@angular/core';

@Injectable()
export class AppleDeviceService {
  constructor(private readonly appleProfileStore: Store<ConfigurationProfile>) {}

  observeAppleDeviceWithLockedFlag(device: AppleDevice): Observable<AppleDevice> {
    return this.appleProfileStore
      .select(AppleProfilesStoreSelectors.selectSingleAppModeBundleIdentifier(device.udid))
      .pipe(
        map((bundleIdentifier) => {
          // Set the 'isLocked' flag to true if the application has an SAM profile
          const applicationsWithLockedFlag = device.managedApplications?.map((managedApplication) => {
            return { ...managedApplication, isLocked: managedApplication.identifier === bundleIdentifier };
          });

          return { ...device, managedApplications: applicationsWithLockedFlag };
        })
      );
  }
}
